
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { SearchService } from '../../../common/services/search.service';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { UserSummary } from '../../../common/models/user';
import { UserService } from '../../../common/services/user.service';
import { GenericDialogComponent } from '../../../common/components/dialog/dialog';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarModule } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrl: './users.component.scss',
    imports: [MatCardModule, MatMenuModule, MatButtonModule, MatPaginatorModule, MatTooltipModule, MatIconModule, MatDialogModule, MatSnackBarModule]
})
export class UsersComponent implements OnInit {
    private destroy$ = new Subject<void>();

    users: UserSummary[] = [];
    filteredUsers: UserSummary[] = [];
    isToggled = false;

   private readonly snackbarConfig: MatSnackBarConfig = {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top'
    };
    

    constructor(
      private router: Router,
      private dialog: MatDialog,
      private snackBar: MatSnackBar,
      private userService: UserService,
      private searchService: SearchService,
      public themeService: CustomizerSettingsService
    ) {}
  
    ngOnInit() {
      this.themeService.isToggled$.pipe(takeUntil(this.destroy$)).subscribe(isToggled => {
        this.isToggled = isToggled;
      });
      this.searchService.currentSearchTerm$.pipe(takeUntil(this.destroy$)).subscribe(term => {
        this.applySearch(term);
      });
   
      this.fetchUsers();
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
  
    fetchUsers(): void {
        this.userService.getUsers().pipe(takeUntil(this.destroy$)).subscribe({
          next: (data) => {
            this.users = data;
            this.filteredUsers = [...this.users];
          },
          error: (error) => {
            console.error('Error fetching users', error);
          }
        });
    }

    applySearch(searchTerm: string): void {
      searchTerm = searchTerm.trim().toLowerCase();
      if (searchTerm) {
        this.filteredUsers = this.users.filter((user: UserSummary) => {
          return (
            user.userName?.toLowerCase().includes(searchTerm) ||
            user.firstName?.toLowerCase().includes(searchTerm) ||
            user.lastName?.toLowerCase().includes(searchTerm)
          );
        });
      } else {
        this.filteredUsers = [...this.users];
      }
    }

    confirmDelete(user: UserSummary): void {
      const dialogRef = this.dialog.open(GenericDialogComponent, {
        width: '50%',
        data: {
          title: 'Potvrdite brisanje',
          message: `Jeste li sigurni da želite obrisati korisnika "${user.userName}"?`,
          confirmButtonText: 'Da',
          cancelButtonText: 'Ne',
        },
      });
  
      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
        if (result === true) {
          this.deleteUser(user.id);
        }
      });
    }
  
    deleteUser(userId: string): void {
      this.userService.deleteUser(userId).pipe(takeUntil(this.destroy$)).subscribe(
        () => {
          this.fetchUsers();
          this.snackBar.open('Korisnik je obrisan', 'Zatvori', this.snackbarConfig);
        },
        (error) => {
          console.error('Error deleting user', error);
        }
      );
    }

    goToToCreateUser(): void {
      this.router.navigate(['administrator', 'users', 'create']);
    }

    goToEditUser(user: UserSummary): void {
      this.router.navigate(['administrator', 'users', user.id.toString(), 'edit']);
    }
  }
